import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Modal,
  Snackbar,
  TextField,
  Typography,
  Tab,
  Tabs,
  useTheme,
} from '@mui/material';

import DescriptionIcon from '@mui/icons-material/Description';
import { DataGrid } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { dateFormatter } from '../../../utils/dateFormatter';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import { getUser } from '../../../redux/usersRedux';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { loadBinsByWarehouseRequest } from '../../../redux/binsRedux';
import {
  addAttachmentsToReportPZ04Request,
  createDecisionPZ04Request,
  generateRedPdfRequest,
  generateYellowPdfRequest,
  loadReportPZ04ByIdRequest,
  sendCreateMailPZ04,
  updateDecisionPZ04Request,
  updateStatusPZ04,
} from '../../../redux/reportsPZ04Redux';
import DecisionFormPZ04 from '../DecisionFormPZ04/DecisionFormPZ04';
import { ATT_URL, IMGS_URL } from '../../../config';
import Micro_1 from '../Micro_1/Micro_1';
import RozlewMicro from '../RozlewMicro/RozlewMicro';
import Micro_2 from '../Micro_2/Micro_2';
import Micro_decision from '../Micro_decision/Micro_decision';
import Micro_5 from '../Micro_5/Micro_5';
import RozlewFiz from '../RozlewFiz/RozlewFiz';
import RN_Fiz_1 from '../RN_Fiz_1/RN_Fiz_1';
import RN_Fiz_3 from '../RN_Fiz_3/RN_Fiz_3';
import RN_Fiz_4 from '../RN_Fiz_4/RN_Fiz_4';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
// TabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.number.isRequired,
//   value: PropTypes.number.isRequired,
// };

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90%', md: '70%' },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const style_modal_rn = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90%', md: '90%' },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
};

const actionPZ04 = {
  ZABLOKOWANE: 'ZABLOKOWANE',
  DO_ZABLOKOWANIA: 'DO_ZABLOKOWANIA',
  DO_UWOLNIENIA: 'DO_UWOLNIENIA',
  UWOLNIONE: 'UWOLNIONE',
  DO_ZNISZCZENIA: 'DO_ZNISZCZENIA',
  ZNISZCZONE: 'ZNISZCZONE',
};

const reasons = [
  { value: 'MIKROBIOLOGIA', label: 'Mikrobiologia' },
  { value: 'FIZ_CHEM', label: 'Fiz/Chem' },
];

const DetailPZ04Form = ({ props }) => {
  const [rnModalOpen, setRrModalOpen] = useState(false);
  const handleReleaseQty = (actions, typeAction) => {
    let qty = 0;
    actions.map((el) => {
      el.actionDetails.map((elA) => {
        if (elA.status === typeAction) {
          qty += parseFloat(elA.qty);
        }
      });
    });

    return parseFloat(qty);
  };

  const countingActualQty = (actions, qty) => {
    let actualQty = parseFloat(qty);
    actions.map((el) => {
      el.actionDetails.map((elA) => {
        if (elA.status === actionPZ04.UWOLNIONE) {
          actualQty -= parseFloat(elA.qty);
        }
        if (elA.status === actionPZ04.ZNISZCZONE) {
          actualQty -= parseFloat(elA.qty);
        }
      });
    });
    return parseFloat(actualQty);
  };

  const handleSelectedBins = (bins) => {
    const selected = [];
    bins.map((el) => {
      selected.push({
        id: el.id,
        binName: el.binList.binName,
        warehouse: el.binList.warehouse,
        quantity: el.quantity === null ? 0 : el.quantity,
        statusBin: el.statusBin,
      });
    });

    return selected;
  };
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [binList, setBinList] = useState([]);
  const [selectedBins, setSelectedBins] = useState(
    props.binBlock.length > 0 ? handleSelectedBins(props.binBlock) : [],
  );
  const [pal, setPal] = useState('');
  const [cas, setCas] = useState('');

  const [valueTabs, setValueTabs] = useState(0);
  const theme = useTheme();
  const [totalCas, setTotalCas] = useState(0);
  const [hl, setHl] = useState(0);
  const [releaseQty, setReleaseQty] = useState(
    props ? handleReleaseQty(props.actions, 'UWOLNIONE') : 0,
  );
  const [destroyQty, setDestroyQty] = useState(
    props ? handleReleaseQty(props.actions, 'ZNISZCZONE') : 0,
  );
  const [actualQty, setActualQty] = useState(
    props ? countingActualQty(props.actions, props.qty) : 0,
  );
  const [comment, setComment] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [action, setAction] = useState('');
  const [decisionStatus, setDecisionStatus] = useState('');
  const [responseStatus, setResponseStatus] = useState('');
  const [responseCode, setResponseCode] = useState('');
  const [alert, setAlert] = useState(false);
  const [actualHu, setActualHu] = useState([]);
  const [attachments, setAttachments] = useState(
    props ? props.attachments : [],
  );
  const user = useSelector((state) => getUser(state));

  const handleAttachments = async (e) => {
    e.preventDefault();
    const files = e.target.files;
    const res = await dispatch(
      addAttachmentsToReportPZ04Request({ files, reportId: props.id }),
    );
    console.log('handleAttachments', res);
  };

  useEffect(() => {
    const start = async () => {
      const res2 = await dispatch(loadReportPZ04ByIdRequest(props.id));
      setAttachments(res2.data.attachments);
      const res = await dispatch(
        loadBinsByWarehouseRequest(user.users.warehouse),
      );
      setBinList(res.data);
    };
    start();
  }, [dispatch, props.id, user.users.warehouse]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAlert(true);

    const cas2 = parseInt(cas);
    const pal2 = parseInt(pal);
    const totalCas = pal2 * props.orderProduct.palletQty + cas2;
    const hl = totalCas * props.orderProduct.casHL;
    setTotalCas(totalCas);
    setHl(hl.toFixed(2));
    const data = {
      reportId: props.id,
      statusReport: 'IN_PROGRESS',
      userId: user.users.id,
      activeDecision: actionPZ04.ZABLOKOWANE,
      comments: comment,
      qty: totalCas.toString(),
    };
    console.log(data);
    const res2 = await dispatch(createDecisionPZ04Request(data));
    console.log(res2);

    if (res2.status === 200 || res2.status === 201) {
      const res = await dispatch(updateStatusPZ04(data));
      if (res.status === 200 || res.status === 201) {
        const data = {
          emailGroup: {
            messageType: 'PZ04_QUARANTINE',
            warehouseCode: res.data.warehouse,
          },
          subject: `Nowa decyzja w raporcie PZ04 - ${res.data.reportNumber}`,
          template: 'confirmReportPZ04',
          reportDetails: res.data,
        };
        await dispatch(sendCreateMailPZ04(data));
      }
      setResponseStatus(res.status);
      setDecisionStatus(res2.status);
      handleModalClose();
      setTimeout(() => {
        navigate('/pz04');
      }, 2000);
    }
  };

  const handleCountHL = (product, qty) => {
    const hl = parseFloat(qty) * product.casHL;
    return hl.toFixed(2);
  };

  const handleCountFullPalletsAndRestCas = (product, qty) => {
    const fullPallets = Math.floor(qty / product.palletQty);
    const restCas = qty % product.palletQty;
    const answer = `${fullPallets} palet + ${restCas} casów`;
    return answer;
  };

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleCloseAlert = () => {
    setAlert(false);
  };

  const handleDecisionAction = async (data) => {
    setAlert(true);

    if (parseFloat(data.qty) === actualQty) {
      console.log('Ilosc zgadza sie');
    }

    const res = await dispatch(updateDecisionPZ04Request(data));

    setResponseCode(res.status);

    if (res.status === 200 && parseFloat(data.qty) === actualQty) {
      const statusData = {
        reportId: data.reportId,
        statusReport: 'DONE',
        qty: props.qty,
      };
      const res2 = await dispatch(updateStatusPZ04(statusData));
      if (res2.status === 200) {
        setTimeout(() => {
          navigate(0);
        }, 2000);
      }
    }
  };

  const handleReasons = (value) => {
    const reason = reasons.filter((el) => el.value === value);
    return reason[0].label;
  };

  const generateYellowCardPDF = async () => {
    let shift = '';
    const productionLine = `Linia ${props.orderBatch.slice(1, 2)}`;
    const hourTimeCreated = dayjs(props.createdAt).format('HH');
    const dateTimeCreated = dayjs(props.createdAt).format('DD.MM.YYYY');
    const expiryDate = dayjs(props.expirityDate).format('DD.MM.YYYY');
    console.log(productionLine);
    if (hourTimeCreated >= 6 && hourTimeCreated < 14) {
      shift = 'Zmiana 1';
    }
    if (hourTimeCreated >= 14 && hourTimeCreated < 22) {
      shift = 'Zmiana 2';
    }
    if (hourTimeCreated >= 22 || hourTimeCreated < 6) {
      shift = 'Zmiana 3';
    }

    const data = {
      image: `${IMGS_URL}/logo2.jpg`,
      dateCreated: `${dateTimeCreated} / ${shift}`,
      reason: handleReasons(props.reason),
      productionLine: productionLine,
      BBT: props.BBT,
      material: `${props.orderProduct.materialNumber}  ${props.orderProduct.description}`,
      productionOrder: props.orderNumber,
      reportNumber: props.reportNumber,
      expiryDate: expiryDate,
      batch: props.orderBatch,
      createdBy: `${props.user.firstName} ${props.user.lastName}`,
      currentUser: `${user.users.firstName} ${user.users.lastName}`,
      comments: props.comments,
    };
    await dispatch(generateYellowPdfRequest(data));
  };

  const generateRedCardPDF = async () => {
    let shift = '';
    const productionLine = `Linia ${props.orderBatch.slice(1, 2)}`;
    const hourTimeCreated = dayjs(props.createdAt).format('HH');
    const dateTimeCreated = dayjs(props.createdAt).format('DD.MM.YYYY');
    const expiryDate = dayjs(props.expirityDate).format('DD.MM.YYYY');
    console.log(productionLine);
    if (hourTimeCreated >= 6 && hourTimeCreated < 14) {
      shift = 'Zmiana 1';
    }
    if (hourTimeCreated >= 14 && hourTimeCreated < 22) {
      shift = 'Zmiana 2';
    }
    if (hourTimeCreated >= 22 || hourTimeCreated < 6) {
      shift = 'Zmiana 3';
    }

    const data = {
      image: `${IMGS_URL}/logo2.jpg`,
      dateCreated: `${dateTimeCreated} / ${shift}`,
      reason: handleReasons(props.reason),
      productionLine: productionLine,
      BBT: props.BBT,
      material: `${props.orderProduct.materialNumber}  ${props.orderProduct.description}`,
      productionOrder: props.orderNumber,
      reportNumber: props.reportNumber,
      expiryDate: expiryDate,
      batch: props.orderBatch,
      createdBy: `${props.user.firstName} ${props.user.lastName}`,
      currentUser: `${user.users.firstName} ${user.users.lastName}`,
      comments: props.comments,
    };
    await dispatch(generateRedPdfRequest(data));
  };
  const handleChangeTabs = (event, newValue) => {
    setValueTabs(newValue);
  };
  const handleRnModalOpen = () => {
    setRrModalOpen(true);
  };
  const handleRnModalClose = () => {
    setRrModalOpen(false);
  };
  console.log(props);
  return (
    <Box sx={{ mt: { xs: 5, md: 3 }, ml: { xs: 2 }, mr: { xs: 2 } }}>
      {responseStatus === 200 && decisionStatus === 201 && (
        <Snackbar
          open={alert}
          autoHideDuration={6000}
          onClose={handleCloseAlert}
        >
          <Alert
            variant="filled"
            onClose={handleCloseAlert}
            severity="success"
            sx={{ width: '100%' }}
          >
            <AlertTitle>Success</AlertTitle>
            Pomyślnie dodano działanie
          </Alert>
        </Snackbar>
      )}
      {responseCode === 200 && (
        <Snackbar
          open={alert}
          autoHideDuration={6000}
          onClose={handleCloseAlert}
        >
          <Alert
            variant="filled"
            onClose={handleCloseAlert}
            severity="success"
            sx={{ width: '100%' }}
          >
            <AlertTitle>Success</AlertTitle>
            Pomyślnie dodano działanie
          </Alert>
        </Snackbar>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
        <Typography
          sx={{ fontStyle: 'italic' }}
          variant="h5"
          component="h2"
          gutterBottom
        >
          {`${t('pz04.title')}: ${props.reportNumber}`}
        </Typography>
        <Box>
          {props.typeReport === 'KWARANTANNA' && (
            <Button
              sx={{ mr: 1 }}
              variant="contained"
              style={{
                backgroundColor: '#FFD700',
                color: 'black',
              }}
              startIcon={<PictureAsPdfIcon />}
              onClick={generateYellowCardPDF}
            >
              {t('pz04.yellowCard')}
            </Button>
          )}
          {props.typeReport === 'PODEJRZENIE_NIEZGODNOSCI' && (
            <Button
              sx={{ mr: 1 }}
              variant="contained"
              color="error"
              startIcon={<PictureAsPdfIcon />}
              onClick={generateRedCardPDF}
            >
              {t('pz04.redCard')}
            </Button>
          )}
          {props.typeReport === 'RAPORT_NIEZGODNOSCI' && (
            <Box>
              <Button
                startIcon={<DescriptionIcon />}
                sx={{ mr: 10 }}
                variant="contained"
                onClick={handleRnModalOpen}
              >
                {t('rnModule.runRn')}
              </Button>
              <Button
                sx={{ mr: 1 }}
                variant="contained"
                color="error"
                startIcon={<PictureAsPdfIcon />}
                onClick={generateRedCardPDF}
              >
                {t('pz04.redCard')}
              </Button>
            </Box>
          )}
        </Box>
      </Box>
      <Divider sx={{ width: '100%', mb: 3, bgcolor: '#C09A53' }} />
      <Typography
        variant="h6"
        component="h2"
        gutterBottom
        sx={{ fontWeight: 'bold' }}
      >
        {t('pz05.basicInfo')}:
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('pz05.dateCreated')}:{' '}
        <Typography
          component="span"
          sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
        >
          {dateFormatter(props.createdAt)}
        </Typography>
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('pz05.list.warehouse')}:{' '}
        <Typography
          component="span"
          sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
        >
          {props.warehouse}
        </Typography>
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('pz05.list.user')}:{' '}
        <Typography
          component="span"
          sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
        >
          {`${props.user.firstName} ${props.user.lastName}`}
        </Typography>
      </Typography>
      <Typography variant="body1" gutterBottom>
        Status:{' '}
        <Typography
          component="span"
          sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
        >
          {t(`pz04.statuses.${props.statusReport}`)}
        </Typography>
      </Typography>
      <Divider sx={{ width: '100%', mt: 1, mb: 3, bgcolor: '#C09A53' }} />
      <Box
        sx={{
          display: { xs: 'block', md: 'flex' },
        }}
      >
        <Box sx={{ width: { xs: '100%', md: '75%' } }}>
          <Typography
            sx={{
              fontWeight: 'bold',
            }}
            variant="h6"
            component="h2"
            gutterBottom
          >
            {t('pz05.reportDetails')}:
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('pz04.type')}:{' '}
            <Typography
              component="span"
              sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
            >
              {t(`pz04.${props.typeReport}`)}
            </Typography>
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('pz04.reason')}:{' '}
            <Typography
              component="span"
              sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
            >
              {t(`pz04.reasons.${props.reason}`)}
            </Typography>
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('pz04.typeLock')}:{' '}
            <Typography
              component="span"
              sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
            >
              {t(`pz04.typesLock.${props.typeLock}`)}
            </Typography>
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('pz05.decisionComments')}:{' '}
            <Typography
              component="span"
              sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
            >
              {props.comments}
            </Typography>
          </Typography>
          {props.releaseDate !== null && (
            <Typography variant="body1" gutterBottom>
              {t('pz04.releaseDate')}:{' '}
              <Typography
                component="span"
                sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
              >
                {dateFormatter(props.releaseDate)}
              </Typography>
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            width: { xs: '100%', md: '25%' },
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography
            sx={{
              fontWeight: 'bold',
            }}
            variant="h6"
            component="h2"
            gutterBottom
          >
            {t('pz05.attachments')}:
          </Typography>

          {attachments.length > 0 &&
            attachments.map((el) => (
              <a
                key={el.fileName}
                href={`${ATT_URL}/${props.id}/${el.fileName}`}
                target="_blank"
                rel="noreferrer"
              >
                {el.fileName}
              </a>
            ))}

          {(user.users.role === 'KONTROLER' || user.users.role === 'ADMIN') && (
            <Button
              component="label"
              variant="contained"
              startIcon={<CloudUploadIcon />}
              sx={{ mt: 2 }}
            >
              {t('button.addAttachment')}
              <VisuallyHiddenInput
                type="file"
                multiple
                onChange={handleAttachments}
              />
            </Button>
          )}
        </Box>
      </Box>
      <Divider sx={{ width: '100%', mt: 1, mb: 3, bgcolor: '#C09A53' }} />
      <Typography
        sx={{
          fontWeight: 'bold',
        }}
        variant="h6"
        component="h2"
        gutterBottom
      >
        {t('pz04.orderDetails')}:
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('pz04.orderNumber')}:{' '}
        <Typography
          component="span"
          sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
        >
          {props.orderNumber}
        </Typography>
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('pz04.materialNumber')}:{' '}
        <Typography
          component="span"
          sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
        >
          {props.orderProduct.materialNumber}
        </Typography>
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('pz04.list.materialName')}:{' '}
        <Typography
          component="span"
          sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
        >
          {props.orderProduct.description}
        </Typography>
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('pz04.brand')}:{' '}
        <Typography
          component="span"
          sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
        >
          {props.orderProduct.brand.description}
        </Typography>
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('pz04.list.batch')}:{' '}
        <Typography
          component="span"
          sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
        >
          {props.orderBatch}
        </Typography>
      </Typography>
      {!props.beerLock ? (
        <Typography variant="body1" gutterBottom>
          {t('pz04.lockStatus')}:{' '}
          <Typography
            component="span"
            sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
          >
            {t('pz04.release')}
          </Typography>
        </Typography>
      ) : props.beerLock && props.statusReport === 'NEW' ? (
        <Typography variant="body1" gutterBottom>
          {t('pz04.lockStatus')}:{' '}
          <Typography
            component="span"
            sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
          >
            {t('pz04.locked')}
          </Typography>
        </Typography>
      ) : (
        <Typography variant="body1" gutterBottom>
          {t('pz04.lockStatus')}:{' '}
          <Typography
            component="span"
            sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
          >
            {t(`pz04.statuses.${props.actions[0].activeDecision}`)}
          </Typography>
        </Typography>
      )}
      {props.beerLock && props.statusReport !== 'NEW' && (
        <>
          <Typography variant="body1" gutterBottom>
            {t('pz04.initialQty')}:{' '}
            <Typography
              component="span"
              sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
            >
              {`${props.qty} cas / ${handleCountHL(
                props.orderProduct,
                props.qty,
              )} hl / ${handleCountFullPalletsAndRestCas(
                props.orderProduct,
                props.qty,
              )}`}
            </Typography>
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('pz04.actualQty')}:{' '}
            <Typography
              component="span"
              sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
            >
              {`${actualQty} cas / ${handleCountHL(
                props.orderProduct,
                actualQty,
              )} hl / ${handleCountFullPalletsAndRestCas(
                props.orderProduct,
                actualQty,
              )}`}
            </Typography>
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('pz04.releaseQty')}:{' '}
            <Typography
              component="span"
              sx={{ fontWeight: 'bold', fontStyle: 'italic', color: '#009900' }}
            >
              {`${releaseQty} cas / ${handleCountHL(
                props.orderProduct,
                releaseQty,
              )} hl / ${handleCountFullPalletsAndRestCas(
                props.orderProduct,
                releaseQty,
              )}`}
            </Typography>
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('pz04.destroyQty')}:{' '}
            <Typography
              component="span"
              sx={{ fontWeight: 'bold', fontStyle: 'italic', color: '#d32f2f' }}
            >
              {`${destroyQty} cas / ${handleCountHL(
                props.orderProduct,
                destroyQty,
              )} hl / ${handleCountFullPalletsAndRestCas(
                props.orderProduct,
                destroyQty,
              )}`}
            </Typography>
          </Typography>
        </>
      )}

      <Divider sx={{ width: '100%', mt: 1, mb: 3, bgcolor: '#C09A53' }} />
      {props.typeLock === 'BLOKADA_GODZIN' && (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="body1" gutterBottom>
            {t('pz04.typesLock.BLOKADA_GODZIN')}:{' '}
          </Typography>
          <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
            <DateTimePicker
              sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
              label={t('pz04.hourBlockFrom')}
              format="DD.MM.YYYY HH"
              views={['year', 'month', 'day', 'hours']}
              value={dayjs(props.hourBlock[0].dateFrom)}
              disabled
              slotProps={{
                textField: {
                  error: false,
                },
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
          {props.endOfOrder ? (
            <FormGroup>
              <FormControlLabel
                sx={{ ml: 1, mb: 1 }}
                control={<Checkbox checked={props.endOfOrder} disabled />}
                label={t('pz04.endOfOrder')}
              />
            </FormGroup>
          ) : (
            <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
              <DateTimePicker
                sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
                label={t('pz04.hourBlockTo')}
                format="DD.MM.YYYY HH"
                disabled
                views={['year', 'month', 'day', 'hours']}
                value={dayjs(props.hourBlock[0].dateTo)}
                slotProps={{
                  textField: {
                    error: false,
                  },
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          )}
        </Box>
      )}
      {props.typeLock === 'BLOKADA_BINOW' && (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="body1" gutterBottom>
            {t('pz04.typesLock.BLOKADA_BINOW')}:{' '}
          </Typography>
          <Autocomplete
            sx={{ mb: 2, mx: 1 }}
            multiple
            id="tags-standard"
            options={binList}
            value={selectedBins}
            getOptionLabel={(option) => option.binName}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label={t('pz04.binList')}
                placeholder="Bin"
              />
            )}
            onChange={(e, value) => setSelectedBins(value)}
          />
        </Box>
      )}
      {props.typeLock === 'BLOKADA_SSCC' && (
        <Typography variant="body1" gutterBottom>
          {t('pz04.typesLock.BLOKADA_SSCC')}:{' '}
          <Typography
            component="span"
            sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
          />
        </Typography>
      )}
      {props.typeLock === 'BLOKADA_SSCC' && props.ssccLock.length > 0 ? (
        // ? props.ssccLock.map((hu) => (
        // <Typography
        //   component="h5"
        //   sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
        //   key={hu.id}
        // >
        //   {hu.sscc}
        // </Typography>
        <DataGrid
          sx={{ width: '30%', height: '350px' }}
          rows={props.ssccLock}
          columns={[
            // { field: 'id', headerName: 'ID', width: 70 },
            { field: 'sscc', headerName: 'SSCC', width: 300 },
            // { field: 'status', headerName: 'Status', width: 200 },
          ]}
          initialState={{
            pagination: { paginationModel: { page: 0, pageSize: 5 } },
          }}
          pageSizeOptions={[5, 10, 25, 50, 100]}
          // checkboxSelection
          // disableSelectionOnClick

          disableRowSelectionOnClick
        />
      ) : // ))
      null}
      {props.typeLock !== 'CALE_ZLECENIE' ? (
        <Divider sx={{ width: '100%', mt: 1, mb: 3, bgcolor: '#C09A53' }} />
      ) : null}
      {props.beerLock &&
      props.statusReport === 'NEW' &&
      (user.users.role === 'ADMIN' || user.users.role === 'KONTROLER') ? (
        <Button
          variant="contained"
          sx={{ mt: 2, bgcolor: '#009900', ':hover': { bgcolor: '#006600' } }}
          onClick={handleModalOpen}
        >
          {t('button.startAction')}
        </Button>
      ) : (
        ''
      )}

      {props.actions.map((el) => (
        <DecisionFormPZ04
          key={el.id}
          material={props.orderProduct}
          action={handleDecisionAction}
          props={el}
        />
      ))}

      <Modal
        open={modalOpen}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            sx={{ fontWeight: 'bold', fontStyle: 'italic', mb: 2 }}
          >
            {t('pz04.blockQtyDescription')}
          </Typography>
          <Box display="flex" sx={{ justifyContent: 'space-evenly' }}>
            <TextField
              sx={{ width: '25%', mr: 2 }}
              label={`${t('beer.qtyPAL')} - ${t('beer.fullPallets')}`}
              variant="outlined"
              value={pal}
              onChange={(e) => setPal(e.target.value)}
            />
            <TextField
              sx={{ width: '25%', mr: 2 }}
              label={`${t('beer.qty')} - ${t('beer.notFull')}`}
              variant="outlined"
              value={cas}
              onChange={(e) => setCas(e.target.value)}
            />
            <TextField
              variant="outlined"
              sx={{ width: '50%' }}
              label={t('pz04.commentsPlaceholder')}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
            <Button
              sx={{
                mt: 2,
                ml: 2,
                color: 'white',
                bgcolor: '#C09A53',
                ':hover': { bgcolor: '#9c7c43' },
              }}
              onClick={handleSubmit}
            >
              {t('button.confirmButton')}
            </Button>
            <Button
              sx={{
                mt: 2,
                bgcolor: '#FF0000',
                ':hover': { bgcolor: '#CC0000' },
              }}
              variant="contained"
              onClick={handleModalClose}
            >
              {t('button.close')}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={rnModalOpen}
        onClose={handleRnModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style_modal_rn}>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            sx={{ fontWeight: 'bold', fontStyle: 'italic', mb: 2 }}
          >
            {props.reportNumber}
          </Typography>
          {/* <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
          <Typography
            variant="body1"
            gutterBottom
            sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
          >
            Moze tutaj dac aktualny status np. 'W trakcie realizacji: rozlew'
          </Typography> */}
          <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />

          {props.reason === 'MIKROBIOLOGIA' ? (
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              // indicatorColor="primary"
              textColor="inherit"
              variant="fullWidth"
              aria-label="full width tabs example"
              sx={{
                '& .MuiTabs-indicator': {
                  backgroundColor: '#C09A53',
                },
              }}
            >
              <Tab label={t('rnModule.laboratory')} {...a11yProps(0)} />
              <Tab label={t('rnModule.packagingLine')} {...a11yProps(1)} />
              <Tab label={t('rnModule.laboratoryResults')} {...a11yProps(2)} />
              <Tab label={t('rnModule.decisionMaker')} {...a11yProps(3)} />
              {props.reason === 'MIKROBIOLOGIA' && (
                <Tab
                  label={t('rnModule.laboratorySummary')}
                  {...a11yProps(4)}
                />
              )}
            </Tabs>
          ) : (
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              // indicatorColor="primary"
              textColor="inherit"
              variant="fullWidth"
              aria-label="full width tabs example"
              sx={{
                '& .MuiTabs-indicator': {
                  backgroundColor: '#C09A53',
                },
              }}
            >
              <Tab label={t('rnModule.laboratory')} {...a11yProps(0)} />
              <Tab label={t('rnModule.packagingLine')} {...a11yProps(1)} />
              <Tab label={t('rnModule.decisionMaker')} {...a11yProps(2)} />
              <Tab label={t('rnModule.repair')} {...a11yProps(3)} />
            </Tabs>
          )}

          <TabPanel value={valueTabs} index={0} dir={theme.direction}>
            {props.reason === 'MIKROBIOLOGIA' ? (
              <Micro_1 props={props} />
            ) : (
              <RN_Fiz_1 props={props} />
            )}
          </TabPanel>
          <TabPanel value={valueTabs} index={1} dir={theme.direction}>
            {props.reason === 'MIKROBIOLOGIA' ? (
              <RozlewMicro props={props} />
            ) : (
              <RozlewFiz props={props} />
            )}
          </TabPanel>
          <TabPanel value={valueTabs} index={2} dir={theme.direction}>
            {props.reason === 'MIKROBIOLOGIA' ? (
              <Micro_2 props={props} />
            ) : (
              <RN_Fiz_3 props={props} />
            )}
          </TabPanel>
          <TabPanel value={valueTabs} index={3} dir={theme.direction}>
            {props.reason === 'MIKROBIOLOGIA' ? (
              <Micro_decision props={props} />
            ) : (
              <RN_Fiz_4 props={props} />
            )}
          </TabPanel>
          {props.reason === 'MIKROBIOLOGIA' && (
            <TabPanel value={valueTabs} index={4} dir={theme.direction}>
              <Micro_5 props={props} />
            </TabPanel>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default DetailPZ04Form;
